// Shared lock state for doors, keyed by an arbitrary lock id rather than per-DoorDef
// -- a doorway connecting two rooms is narratively one door, so both rooms' door
// definitions reference the same lock id and unlocking from either side unlocks both.
// In-memory only -- survives New Game not touching it, but not a reload, unless
// restored from a save (see gameSave.ts/ui.ts's loadGame()). As of 2026-07-30
// (sim extraction step 2) the record itself lives in the shared WorldState; this
// module is the accessor layer over it, with an unchanged public API.
import { getWorld } from './activeWorld';

function locks(): Record<string, boolean> {
  return getWorld().doorLocks;
}

export function isDoorLocked(lockId: string): boolean {
  return locks()[lockId] ?? true;
}

export function setDoorLocked(lockId: string, value: boolean): void {
  locks()[lockId] = value;
}

export function resetDoors(): void {
  const l = locks();
  for (const key of Object.keys(l)) delete l[key];
}

// Whole-record snapshot/restore for gameSave.ts.
export function getAllDoorLocks(): Record<string, boolean> {
  return { ...locks() };
}

export function setAllDoorLocks(data: Record<string, boolean>): void {
  const l = locks();
  for (const key of Object.keys(l)) delete l[key];
  Object.assign(l, data);
}
